<template>
  <div class="subpage main_area">
    <div class="fullpage_white subpage">
      <div class="sponsor_menu infotab">
        <div class="layout aboutus_layout">
          <div class="infotab_bg cs_type_menu about_menu">
            <div class="sponsor_menu_item about_item">
              <a class="active">
                <div class="title">新手指南</div>
              </a>
            </div>
            <div class="sponsor_menu_item about_item">
              <a class="">
                <div class="title">常见问题</div>
              </a>
            </div>
            <div class="sponsor_menu_item about_item">
              <a class="">
                <div class="title">联系我们</div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <!--新手指南-->
      <div class="detail_area" style="">
        <div class="faq_container">
          <div class="deposit_container cs_guide_container layout">
            <div class="deposit_header cs_header">
              <div>开户</div>
            </div>
          </div>
          <div class="block_content guide_list">
            <div class="question">
              <div class="svg"></div>
              <div class="title">如何注册？</div>
            </div>
            <div class="answer" style="display: none; height: 171px; padding-top: 0px; margin-top: 0px; padding-bottom: 0px; margin-bottom: 0px">
              <div class="answer_content">
                <p class="answer_title">【网页版】</p>
                <p>点击网站右上角 “注册” 按钮，并依照页面提示填写资料，即可完成注册。</p>
                <p class="answer_title">【APP/网页手机版】</p>
                <p>点击主页下方中央红色 “登录” 按钮，再点击登入页面下方 “注册” 按钮，依照页面提示填写资料，即可完成注册。</p>
              </div>
            </div>
          </div>
          <div class="block_content guide_list">
            <div class="question">
              <div class="svg"></div>
              <div class="title">忘记账号？</div>
            </div>
            <div class="answer" style="display: none; height: 54px; padding-top: 0px; margin-top: 0px; padding-bottom: 0px; margin-bottom: 0px">
              <div class="answer_content">若您忘记了您的账号，敬请联系 24 小时在线客服，将有专人为您服务！</div>
            </div>
          </div>
          <div class="block_content guide_list">
            <div class="question">
              <div class="svg"></div>
              <div class="title">忘记密码？</div>
            </div>
            <div class="answer" style="display: none; height: 92px; padding-top: 0px; margin-top: 0px; padding-bottom: 0px; margin-bottom: 0px">
              <div class="answer_content">您可在登入页面中，透过忘记密码功能，填写您的会员帐号与手机号码，即可取回您当初设置的密码。当您无法收取手机短信时，您也可以联系 24 小时在线客服人员，协助您取回您的账号密码。</div>
            </div>
          </div>
          <div class="block_content guide_list last">
            <div class="question">
              <div class="svg"></div>
              <div class="title">如何修改个人信息?</div>
            </div>
            <div class="answer" style="display: none; height: 111px; padding-top: 0px; margin-top: 0px; padding-bottom: 0px; margin-bottom: 0px">
              <div class="answer_content">注册成功后，您可在 “账户安全中心” 绑定您的个人信息，基于安全考量，绑定个人信息后，不得擅自修改。如欲更新您的个人信息及资料，敬请联系我们的 24 小时在线客服人员，我们将会与您核实您的身份信息，并为您更新您的资料。</div>
            </div>
          </div>
          <div class="deposit_container cs_guide_container layout">
            <div class="deposit_header cs_header">
              <div>存款</div>
            </div>
          </div>
          <div class="block_content guide_list">
            <div class="question">
              <div class="svg"></div>
              <div class="title">如何于【网页版】申请存款？</div>
            </div>
            <div class="answer" style="display: none; height: 203px; padding-top: 0px; margin-top: 0px; padding-bottom: 0px; margin-bottom: 0px">
              <div class="answer_content">存款前，请确保您已经成功注册成为 “澳门金沙集团” 的会员。进行存款前，请先登录您的会员账号。 于网页版申请存款，您可于网页左侧的快捷选单中找到 “钱包”，选择 “存款”，或将游标悬停在上方“账号” 处，可打开操作选单，选择 “存款”。</div>
              <div class="deposit_content active" id="pay_offline">
                <div class="answer_content">
                  <p>注记：线下存款的银行帐户将随机生成。每次存款前，请重新重新获取存款帐户。若入款至已过期帐户，我们将无法查收，恕不负责！存款金额将随机生成小数，请按照 生成之金额进行存款，以确保您的存款快速到账！</p>
                </div>
              </div>
            </div>
          </div>
          <div class="block_content guide_list last">
            <div class="question">
              <div class="svg"></div>
              <div class="title">如何于【APP/手机网页版】申请存款？</div>
            </div>
            <div class="answer" style="display: none; height: 238px; padding-top: 0px; margin-top: 0px; padding-bottom: 0px; margin-bottom: 0px">
              <div class="answer_content">
                <p>存款前，请确保您已经成功注册成为 “澳门金沙集团” 的会员。进行存款前，请先登录您的会员账号。 于 APP/手机网页版申请存款，您可于下方的主选单中点选 “钱包”，进入钱包后，可在上方选择 “存款”。</p>
              </div>
              <div class="answer_content">
                <p>进入 “存款” 后，选择您方便使用的存款通道，依照提示步骤进行存款即可。</p>
              </div>
              <div class="mdeposit_content active" id="mpay_offline">
                <div class="answer_content">
                  <p>注记：线下存款的银行帐户将随机生成。每次存款前，请重新重新获取存款帐户。若入款至已过期帐户，我们将无法查收，恕不负责！存款金额将随机生成小数，请按照 生成之金额进行存款，以确保您的存款快速到账！</p>
                </div>
              </div>
            </div>
          </div>
          <div class="deposit_container cs_guide_container layout">
            <div class="deposit_header cs_header">
              <div>取款</div>
            </div>
          </div>
          <div class="block_content guide_list">
            <div class="question">
              <div class="svg"></div>
              <div class="title">如何于【网页版】取款？</div>
            </div>
            <div class="answer" style="display: none; height: 35px; padding-top: 0px; margin-top: 0px; padding-bottom: 0px; margin-bottom: 0px">
              <div class="answer_content">
                <p>首次取款请先绑定您的银行卡及设置取款密码。</p>
              </div>
            </div>
          </div>
          <div class="block_content guide_list last">
            <div class="question">
              <div class="svg"></div>
              <div class="title">如何于【APP/手机网页版】取款？</div>
            </div>
            <div class="answer" style="display: none; height: 35px; padding-top: 0px; margin-top: 0px; padding-bottom: 0px; margin-bottom: 0px">
              <div class="answer_content">
                <p>首次取款请先绑定您的银行卡及设置取款密码。</p>
              </div>
            </div>
          </div>
          <div class="deposit_container cs_guide_container layout">
            <div class="deposit_header cs_header">
              <div>转账</div>
            </div>
          </div>
          <div class="block_content guide_list">
            <div class="question">
              <div class="svg"></div>
              <div class="title">如何于【网页版】转账?</div>
            </div>
            <div class="answer" style="display: none; height: 73px; padding-top: 0px; margin-top: 0px; padding-bottom: 0px; margin-bottom: 0px">
              <div class="answer_content">
                <p>于免转模式中，您将无需手动进行任何操作，账户中的金钱将会在您进入游戏时，自动转入游戏钱包中。若于一般模式中。</p>
              </div>
            </div>
          </div>
          <div class="block_content guide_list last">
            <div class="question">
              <div class="svg"></div>
              <div class="title">如何于【APP/手机网页版】转账？</div>
            </div>
            <div class="answer" style="display: none; height: 73px; padding-top: 0px; margin-top: 0px; padding-bottom: 0px; margin-bottom: 0px">
              <div class="answer_content">
                <p>
                  于免转模式中，您将无需手动进行任何操作，账户中的金钱将会在您进入游戏时，自动转入游戏钱包中。若于一般模式中。
                  <!-- ，请参考图片说明 -->。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--常见问题-->
      <div class="detail_area" style="display: none">
      <div class="faq_container"  v-html="dataBox1.content"></div>
        <div class="faq_container" v-if="false">
          <div class="block_content">
            <div class="question">
              <div class="svg"></div>
              <div class="title">开户是否会收取费用？</div>
            </div>
            <div class="answer">
              <div class="answer_content">在 澳门金沙集团 开户是免费的，最低存款金额为 1 元，取款一般 0-3 分钟内到账，澳门金沙集团 不收取任何手续费。</div>
            </div>
          </div>
          <div class="block_content">
            <div class="question">
              <div class="svg"></div>
              <div class="title">开户是否要填写真实姓名？</div>
            </div>
            <div class="answer">
              <div class="answer_content">您可以通过游戏的视频影像进行监查，视频内的画面，均与各大娱乐城现场所播放的画面是同步的。我们在每一个视频上，都配备一个确认真实性的电话，您可拨打此号码确认所有游戏结果均为真实的实时结果。。</div>
            </div>
          </div>
          <div class="block_content">
            <div class="question">
              <div class="svg"></div>
              <div class="title">如何证明游戏结果是实时的？</div>
            </div>
            <div class="answer">
              <div class="answer_content">您可以通过游戏的视频影像进行监查，视频内的画面，均与各大娱乐城现场所播放的画面是同步的。我们在每一个视频上，都配备一个确认真实性的电话，您可拨打此号码确认所有游戏结果均为真实的实时结果。</div>
            </div>
          </div>
          <div class="block_content">
            <div class="question">
              <div class="svg"></div>
              <div class="title">澳门金沙集团 的信誉如何？</div>
            </div>
            <div class="answer">
              <div class="answer_content">
                澳门金沙集团 拥有欧洲马耳他博彩管理局（MGA）、英国 GC 监督委员会（Gambling Commission）和菲律宾政府博彩委员会（Pagcor）颁发的合法执照。澳门金沙集团
                注册于英属维尔京群岛，是受国际博彩协会认可的合法博彩公司。我们提供诚信、专业及安全的平台，让您的生活充满健康的情趣、刺激与成就。其他详情，请参阅 “关于我们” 。
              </div>
            </div>
          </div>
          <div class="block_content">
            <div class="question">
              <div class="svg"></div>
              <div class="title">在 澳门金沙集团 的信息是否安全？</div>
            </div>
            <div class="answer">
              <div class="answer_content">澳门金沙集团 系统绝对安全！我们绝不泄漏客户的个人资料给任何商业机构。此外，我们亦要求有交易往来的银行、信用卡中转代理等机构，严格保密客户的资料。所有的存款将视为贸易户口，不会交给其它的人士进行任何不相关的交易。</div>
            </div>
          </div>
          <div class="block_content">
            <div class="question">
              <div class="svg"></div>
              <div class="title">网上博彩是否合法？</div>
            </div>
            <div class="answer">
              <div class="answer_content">部分国家或地区当地法律禁止博彩，在这种情况下，请您务必遵守当地法律，如有任何疑问，请寻求当地法律部门的建议。澳门金沙集团 不能、亦不会接受任何人士违反当地法律，并无法为此所致之任何问题负起责任。</div>
            </div>
          </div>
          <div class="block_content">
            <div class="question">
              <div class="svg"></div>
              <div class="title">当网页打不开的时候，怎么办？</div>
            </div>
            <div class="answer">
              <div class="answer_content">您可以联系在线客服要备用网址，当您常用的网址打不开时，可尝试由备用网址进入我们的网站。</div>
            </div>
          </div>
        </div>
      </div>
      <!--联系我们-->
      <div class="detail_area" style="display: none">
      <div class="faq_container"  v-html="dataBox4.content"></div>

        <div class="contact_container">
          <div class="contactus_layout">
            <div class="block_content altContact contact_style" data-url="http://llk.ytwrncbs.com/6ddc5c94dcd4ce53c69jkfle-kelid0d6c051c090e0f0b080a0b0406070f0b0d020f00030186e20d0d4ec847ed386">
              <div class="contact_box" @click="$parent.openKefu">
                <div class="title contact_text">
                  <div class="icon" style="position: relative"><img alt="" src="/static/image/contact_cs.png" /></div>
                  24小时在线客服
                  <div class="contact_value">客户服务</div>
                </div>
              </div>
            </div>
            <!-- <div class="block_content altContact contact_style" data-url="tel:(+853) 62552345">
              <div class="contact_box">
                <div class="title contact_text">
                  <div class="icon" style="position: relative"><img alt="" src="/static/image/contact_phone.png" /></div>
                  (+853) 62552345
                  <div class="contact_value">联系电话</div>
                </div>
              </div>
            </div>
            <div class="block_content altContact contact_style" data-url="mailto:jsjt9500@gmail.com">
              <div class="contact_box">
                <div class="title contact_text">
                  <div class="icon" style="position: relative"><img alt="" src="/static/image/contact_email.png" /></div>
                  jsjt9500@gmail.com
                  <div class="contact_value">电子邮件</div>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'customer',
  data() {
	 // 1常见问题  2隐私政策  3免责说明  4联系我们  5代理加盟  7关于我们 8博彩责任  

    return {dataBox1: {}, dataBox2: {}, dataBox3: {}, dataBox4: {}, dataBox5: {},  dataBox7: {}, dataBox8: {}};
  },
  created() {
    let that = this;
        let arr = [1, 2, 3, 4, 5, 7, 8];
    arr.forEach(el => {
      that.getAllCont(el);
    });
  },
  methods: {
       getAllCont(type) {
      let that = this;
      that.$parent.showLoading();

      that.$apiFun
        .post('/api/article', { type })
        .then(res => {
          let name = 'dataBox' + type;
          that[name] = res.data;
          console.log(type);
          console.log(that[name].content);
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
  },
  mounted() {
    let that = this;
    //页面内容切换
    $('.about_menu .about_item').click(function () {
      var index = $(this).index();
      $('.about_menu .about_item a').removeClass('active').eq(index).addClass('active');
      $('.detail_area').fadeOut(0).eq(index).fadeIn(300);
    });
    //展开详情
    $('.faq_container > .block_content > .question')
      .off('click')
      .click(function () {
        var thisNum = $(this).parent().index() + 1;
        $('.faq_container > .block_content:not(:nth-child(' + thisNum + '))').removeClass('active');
        $('.faq_container > .block_content > .answer').stop().slideUp(300);
        $(this).parent().toggleClass('active');
        $(this).parent().children('.answer').stop().slideToggle(300);
      });
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/mode/customer.vue